import type { Feature } from "@/types/feature";

// Single source of truth for which features have synthetic preview-mode
// data wired up. Drives both the banner's route gating (PreviewBanner)
// and the feature splash bypass (useFeatureAccess). Adding a new
// preview-mode feature here is the only edit needed for both consumers
// to pick it up.
type PreviewModeFeature = {
  pathPrefix: string;
  // Set when the preview-mode feature corresponds to a Feature gated by
  // useFeatureAccess. Omit for preview-mode features outside that flow
  // (e.g. routes not represented in the Feature enum).
  feature?: Feature;
};

export const PREVIEW_MODE_FEATURES: readonly PreviewModeFeature[] = [
  { pathPrefix: "/web-analytics", feature: "web_analytics" },
  { pathPrefix: "/funnels", feature: "funnels" },
  { pathPrefix: "/surveys", feature: "surveys" },
  { pathPrefix: "/ai-chat", feature: "ai_chat" },
];

export const PREVIEW_MODE_PATH_PREFIXES: readonly string[] =
  PREVIEW_MODE_FEATURES.map((f) => f.pathPrefix);

export const PREVIEW_MODE_GATED_FEATURES: ReadonlySet<Feature> = new Set(
  PREVIEW_MODE_FEATURES.map((f) => f.feature).filter(
    (f): f is Feature => f !== undefined,
  ),
);

export function pathHasPreviewData(pathname: string): boolean {
  return PREVIEW_MODE_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + "/"),
  );
}
